<template>
  <b-modal
    v-model="visible"
    centered
    hide-footer
    size="md"
    :title="messages.MODAL_TITLE"
    modal-class="operaciones-status-editor"
    :no-close-on-backdrop="saving"
    :no-close-on-esc="saving"
    @hidden="handleHidden"
  >
    <b-form @submit.prevent="handleSave">
      <b-form-group label-class="text-grey font-weight-bold" label="Número de OC *">
        <b-form-input
          v-model="form.numeroOc"
          class="grey-input"
          placeholder="Ingrese número de OC"
          :disabled="saving"
          :state="errors.numeroOc ? false : null"
        />
        <b-form-invalid-feedback v-if="errors.numeroOc">
          {{ errors.numeroOc }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label-class="text-grey font-weight-bold" label="Migo *">
        <b-form-input
          v-model="form.migo"
          class="grey-input"
          placeholder="Ingrese número Migo"
          :disabled="saving"
          :state="errors.migo ? false : null"
        />
        <b-form-invalid-feedback v-if="errors.migo">
          {{ errors.migo }}
        </b-form-invalid-feedback>
      </b-form-group>

      <div class="operaciones-status-editor__actions">
        <b-button class="bg-grey-btn px-4" :disabled="saving" @click="handleCancel">
          {{ messages.CANCEL_BUTTON }}
        </b-button>
        <b-button
          class="bg-orange-btn px-4"
          type="submit"
          :disabled="saving"
        >
          <b-spinner v-if="saving" small class="mr-1" />
          {{ saving ? "Guardando..." : messages.SAVE_BUTTON }}
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { MESSAGES } from "@/services/operaciones/operaciones.constants";

export default {
  name: "OperacionesStatusEditor",

  props: {
    value: {
      type:    Boolean,
      default: false,
    },
    row: {
      type:    Object,
      default: null,
    },
    saving: {
      type:    Boolean,
      default: false,
    },
  },

  data() {
    return {
      messages: MESSAGES,
      form:     this.createEmptyForm(),
      errors:   {},
    };
  },

  computed: {
    visible: {
      get()          { return this.value; },
      set(nextValue) { this.$emit("input", nextValue); },
    },
  },

  watch: {
    row: {
      immediate: true,
      handler(nextRow) {
        this.form   = this.mapRowToForm(nextRow);
        this.errors = {};
      },
    },
  },

  methods: {
    createEmptyForm() {
      return {
        idLiquidacionCab: null,
        codigoTienda:     null,
        numeroOc:         "",
        migo:             "",
      };
    },

    mapRowToForm(row) {
      if (!row) return this.createEmptyForm();

      return {
        idLiquidacionCab: row.idLiquidacionCab,
        codigoTienda:     row.codigoTienda,
        numeroOc:         row.numeroOc || "",
        migo:             row.migo     || "",
      };
    },

    validar() {
      this.errors = {};

      if (!this.form.numeroOc || !this.form.numeroOc.trim()) {
        this.errors.numeroOc = "El número de OC es obligatorio";
      }

      if (!this.form.migo || !this.form.migo.trim()) {
        this.errors.migo = "El Migo es obligatorio";
      }

      return Object.keys(this.errors).length === 0;
    },

    handleSave() {
      if (!this.validar()) return;

      this.$emit("save", {
        idLiquidacionCab: this.form.idLiquidacionCab,
        codigoTienda:     this.form.codigoTienda,
        estadoOc:         "COMPLETADO",
        numeroOc:         this.form.numeroOc.trim(),
        migo:             this.form.migo.trim(),
      });
    },

    handleCancel() {
      this.visible = false;
    },

    handleHidden() {
      this.$emit("hidden");
    },
  },
};
</script>